export default "__VITE_ASSET__lAC9aQWK__"